var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-app":""}},[_c('v-menu',{attrs:{"attach":"#header-nav-wrap","absolute":""}},[_c('v-icon',{staticClass:"mobile-menu-icon",attrs:{"slot":"activator"},slot:"activator"},[_vm._v("menu")]),_c('NavLinks',{staticClass:"mobile-nav-links"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }